export enum Types {
	CADASTRAR_ORGAO = '@SGU/CADASTRAR_ORGAO',
	CADASTRAR_ORGAO_SUCCESS = '@SGU/CADASTRAR_ORGAO_SUCCESS',
	CADASTRAR_ORGAO_FAILURE = '@SGU/CADASTRAR_ORGAO_FAILURE',
	CADASTRAR_ORGAO_CLEAR = '@SGU/CADASTRAR_ORGAO_CLEAR',
}

export interface CadastrarOrgao {
	status: number;
	data: null | OrgaoData;
}

interface OrgaoData {
	status: string;
	statusMensagem: string;
}

export interface CadastrarOrgaoRequest {
	id?: number | string;
	descricao: string;
	codigoSefaz: number | string;
	mainframe: boolean;
	flHabilitado: boolean;
}
